<template>
    <v-card @click="Open"
            elevation="4"
            color="blue darken-3"
            dark
            class="text-sm-center"
            style="cursor:pointer;">
        <v-card-title>
            <h2 class="mx-auto my-0">Young Persons'<br /><span class="text-h6">(Under 22)</span><br />Free Bus Travel</h2>
        </v-card-title>
        <v-card-title>
            <v-icon large class="mx-auto my-0">fas fa-bus</v-icon>
        </v-card-title>
        <v-card-actions>
            <v-btn dark text block>Learn About Free Bus Travel</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
    import ctrlOpenMixin from '@/views/components/mixins/base/ctrlOpen.js'

    export default {
        mixins: [ctrlOpenMixin],
        methods: {
            Open() { this.CtrlOpen('/free-bus-travel'); }
        },
    }
</script>
